import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,

} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Restaurant from './restaurant/Index';
import Checkout from './checkout/Index';
import Login from './user/Login';
import Payment from './payment/Payment';
import Order from './order/Order';
import Finalcart from './finalcart/Finalcart';
import Orders from './orders/Orders';
import Table from './table/Table';
import VerifyPayment from './verifypayment/VerifyPayment';
import CurrentOrders from './currentorders/CurrentOrders';
import About from './about/About';
import PrivacyPolicy from './provicypolicy/PrivacyPolicy';
import './style.css';
import './custom.css';



function App() {
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/privacy-policy">
            <PrivacyPolicy />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/checkout">
            <Checkout />
          </Route>
          <Route path="/payment">
            <Payment />
          </Route>
          <Route path="/order/:id">
            <Order />
          </Route>
          <Route path="/finalcart">
            <Finalcart />
          </Route>
          <Route path="/orders">
            <Orders />
          </Route>
          <Route path="/table">
            <Table />
          </Route>
          <Route path="/currentorder">
            <CurrentOrders />
          </Route>
          <Route path="/verifypayment/:orderid">
            <VerifyPayment />
          </Route>
          <Route path="/:table">
            <Restaurant />
          </Route>
          <Route path="/">
            <Restaurant />
          </Route>
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
